import { schema } from 'normalizr';

export const rawMatDataReviewSchema = new schema.Entity('rawMatDataReviews', {}, { idAttribute: 'RawMatDataReviewId' });
export const rawMatDataReviewListSchema = [rawMatDataReviewSchema];
